<template>
  <!-- <v-app dark> -->
  <v-app>
    <v-navigation-drawer
      temporary
      v-model="drawer"
      :disable-resize-watcher="false"
      :disable-route-watcher="false"
      app
      :width="265"
    >
      <v-list
        dense
        >
        <v-list class="pt-3">

          <!-- <v-list-tile avatar> -->
          <v-list-tile>
            <v-list-tile-avatar :tile="true"  size="36">
              <img src="static/diux-60.png">
              <!-- <img src="static/diux-logo-60-bw.png"> -->
            </v-list-tile-avatar>
            <!-- <v-list-tile-content> -->
              <v-list-tile-title>
                <span class="navpanel-title-text">xVIEW CHALLENGE</span>
              </v-list-tile-title>
            <!-- </v-list-tile-content> -->
          </v-list-tile>
        </v-list>

        <v-divider class="mt-2"></v-divider>

        <v-subheader class='mt-2 gray--text text--darken-1'>CHALLENGE</v-subheader>
        <v-list-tile v-for="item in challengeItems" :key="item.text" :to="item.link">
          <v-list-tile-content>
            <v-list-tile-title class='ml-3'>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-subheader class="mt-2 gray--text text--darken-1">DATA</v-subheader>
        <v-list-tile v-for="item in datasetItems" :key="item.text" :to="item.link">
          <v-list-tile-content>
            <v-list-tile-title class='ml-3'>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-spacer class='mt-2'></v-spacer>  <!-- spacer -->
        <v-list-tile v-for="item in otherItems" :key="item.text" :to="item.link">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>
    <!-- <v-toolbar color="primary" fixed clipped-left app dark> -->
      <v-toolbar
        color="secondary"
        fixed
        dense
        prominent
        dark
        app
        clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title
        :style="$vuetify.breakpoint.width > 1000 && 'width: 240px'"
        class="ml-0 pl-0"
        :class="$vuetify.breakpoint.width <= 1000 && 'pr-3'"
      > 
        <span class="hidden-xs-only">xView</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- <v-btn v-if="$currentUser" color="primary" v-on:click="logout">Logout</v-btn> -->
        <!-- <v-btn flat color="error" v-on:click="logUid">LOG UID</v-btn> -->
        <!-- <v-btn flat color="error" v-on:click="logToken">LOG TOKEN</v-btn> -->
        <v-btn flat v-if='showLoginButton' to="/login">Log in</v-btn>
        <!-- <v-btn flat @click.stop="dialog = true">Login2</v-btn> -->
        <v-btn flat v-if='showSubmissionsButton' to="/submissions">My Submissions</v-btn>

        <v-btn flat v-if='showLogoutButton' v-on:click="logout">Log out</v-btn>
        <v-btn flat icon to='/profile'>
          <v-icon v-if='showLogoutButton'>account_circle</v-icon>
        </v-btn>
      </v-toolbar-items>

    </v-toolbar>

    <v-content style="background-color: #fafafa;">
      <v-container xs10 sm8 class="my-3">
        <router-view></router-view/>
      </v-container>
    </v-content>

    <v-spacer style="background-color: #fafafa;"></v-spacer>
    <v-footer
      height=auto
      class="pa-3"
      style="background-color: #fafafa;"
      >
      <v-spacer></v-spacer>
      <img src="static/xView-satellite-blue-small-rot.png" height="40px" class="my-2">
      <img src="static/earth.png" height="55px">  <!-- use PNG for transparency --> 
    </v-footer>

  </v-app>
</template>

<script>
// import axios from 'axios'
import firebase from 'firebase'
// import Login2 from '@/components/Login2'

export default {
  name: 'App',
  // components: {
  //   Login2
  // },
  data () {
    return {
      // clipped: false,
      dialog: false,
      widgets: false,
      drawer: false,
      // drawer: true,
      hiddenRoute: true,
      // showLogoutButton: false,
      // showLoginButton: true,
      currentUser: false,
      // currentUser: firebase.auth().currentUser,
      // miniVariant: false,
      // right: true,
      // rightDrawer: false,
      // title: 'xVIEW',

      // overviewItems: [
      //   // { icon: 'home', text: 'Overview', link: 'overview' },
      // ],
      challengeItems: [
        { text: 'Description', link: 'challenge-description' },
        { text: 'Evaluation', link: 'challenge-evaluation' },
        { text: 'Awards', link: 'challenge-awards' }
        // { text: 'Submit', link: 'submit' }  // disabled after deadline
      ],
      datasetItems: [
        { text: 'Explore', link: 'data-explore' },
        { text: 'Format', link: 'data-format' },
        { text: 'Download', link: 'data-download' }
      ],
      otherItems: [
        { text: 'Baseline', link: 'baseline' },
        { text: 'Tutorial', link: 'tutorial' },
        // { text: 'Leaderboard ', link: 'leaderboard' },
        { text: 'Discussion', link: 'discussion' },
        { text: 'Rules', link: 'rules' },
        { text: 'FAQ', link: 'faq' },
        { text: 'External', link: 'external-resources' }
      ],
      idToken: '',
      error: ''
    }
  },
  methods: {
    clear () {
      this.$refs.form.reset()
    },
    logout: function () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
        .then(function () {
          console.log('Signed out, goodbye.')
        })
        .catch(function (err) {
          console.log('Oops, something went wrong while logging out: ', err.message)
        })
      })
    },
    logToken: function () {
      firebase.auth().currentUser.getIdToken(true)
        .then(function (idToken) {
          console.log('token: ', idToken)
        }).catch(function (error) {
          console.log('error: ', error)
        })
    },
    logUid: function () {
      console.log(firebase.auth().currentUser.uid)
    }
    // signIn: function () {
    //   firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
    //     function (user) {
    //       alert('You are now logged in.')
    //     },
    //     function (err) {
    //       alert('Oops, something went wrong: ' + err.message)
    //     })
    // }
  },
  mounted () {
    // grab the user state to show (or not) various UX elements
    this.$set(this.$data, 'currentUser', firebase.auth().currentUser)

    // by default, don't show the nav drawer unless user is logged in
    if (firebase.auth().currentUser) {
      this.$set(this.$data, 'drawer', true)
      // this.$set(this.$data, 'showLogoutButton', true)
    }
    // else {
    //   this.$set(this.$data, 'showLogoutButton', false)
    // }
  },
  watch: {
    $route: function () {
      // Checks meta params on a route to see if navbar should display
      // if (this.$route.path === '/login') {
      //   this.$set(this.$data, 'drawer', false)
      // }

      // don't display the side menu when user is not logged in
      if (this.$route.meta.requiresAuth && !firebase.auth().currentUser) {
        this.$set(this.$data, 'drawer', false)
      }
      // if (firebase.auth().currentUser) {
      //   this.$set(this.$data, 'showLogoutButton', true)
      //   this.$set(this.$data, 'showLoginButton', false)
      // }
      // if (!firebase.auth().currentUser) {
      //   this.$set(this.$data, 'showLogoutButton', false)
      //   this.$set(this.$data, 'showLoginButton', true)
      // }
    }
  },
  computed: {
    appTitle () {
      return this.$store.getters.appTitle
    },
    showLoginButton: function () {
      if (firebase.auth().currentUser) {
        return false
      } else {
        return true
      }
    },
    showLogoutButton: function () {
      if (firebase.auth().currentUser) {
        return true
      } else {
        return false
      }
    },
    showSubmissionsButton: function () {
      if (firebase.auth().currentUser) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
  .navpanel-title-text {
    font-size: 18px;
    color: #242424;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue